import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import { AvForm } from 'availity-reactstrap-validation';
import classnames from 'classnames';

const FormModal =
  ({
    showModal,
    toggleModal,
    modalTitle,
    modalTitleIcon,
    onValidSubmit,
    affirmativeActionText,
    children,
  }) => (
    <Modal isOpen={showModal} toggle={toggleModal} tabIndex="-1" role="dialog" aria-labelledby="modal" aria-hidden="true">
      <AvForm onValidSubmit={onValidSubmit}>
        <ModalHeader toggle={toggleModal}>
          <span className={classnames('text-secondary', modalTitleIcon)} /> {modalTitle}
        </ModalHeader>
        <ModalBody>
          {children}
        </ModalBody>
        <ModalFooter>
          <Button color="link" onClick={toggleModal}>Cancel</Button>
          <Button color="info" type="submit">{affirmativeActionText}</Button>
        </ModalFooter>
      </AvForm>

    </Modal>
  );

FormModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  onValidSubmit: PropTypes.func.isRequired,
  modalTitle: PropTypes.string.isRequired,
  modalTitleIcon: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  affirmativeActionText: PropTypes.string,
};

FormModal.defaultProps = {
  affirmativeActionText: 'Save',
};

export default FormModal;



// WEBPACK FOOTER //
// ./src/components/core/FormModal.js